import { useMutation } from '@tanstack/react-query'

import { mockQuery } from '@/utils/mocks'

const useArchiveCourse = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutation({
    mutationFn: async (courseId: string) => {
      // TODO: Remove API mocks - https://panowie.atlassian.net/browse/RG-90
      await mockQuery(courseId)
    },
    onSuccess,
    onError
  })

export default useArchiveCourse
